module.exports = __webpack_public_path__ + "static/img/s114.595b60b7.png";